import _merge from 'lodash/merge';
import { FULL_HD, HD, safetyMargins, RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import { makeThemeColor, PRIMARY, TERTIARY } from '@tornado-rdk/theme';
import { FONT, getFont } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../utils/style';
import { sizes, templates } from './AlertView.constants';
import { middle } from '../utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const GAP = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const TEXT_GAP = {
  [HD]: 8,
  [FULL_HD]: 16,
};

export const LOGO_HEIGHT = {
  [HD]: 64,
  [FULL_HD]: 72,
};

export const getWordWrapWidth = (screenSize, w) =>
  Math.round((w || sizes[templates.AlertView][RENDERING_CONTEXT.GENERAL][screenSize].w) * 0.75);

export const colors = {
  text: makeThemeColor(PRIMARY),
  background: makeThemeColor(TERTIARY),
};

export const getAdaptiveSizes = (width, height) => ({
  w: width,
  h: height,
  Background: {
    w: width,
    h: height,
  },
  Container: {
    w: width,
    h: height,
  },
});

export const getInitialStyle = ({ screenSize, colorMode } = defaultContext) => {
  const { w, h } = sizes[templates.AlertView][RENDERING_CONTEXT.GENERAL][screenSize];
  const defaultSizes = getAdaptiveSizes(w, h);
  const textColor = colors.text[colorMode];

  return _merge(defaultSizes, {
    color: colors.background[colorMode],
    Background: {},
    Logo: {
      mountX: 0.5,
      x: middle,
      y: safetyMargins.vertical[screenSize],
      h: LOGO_HEIGHT[screenSize],
    },
    Container: {
      flex: {
        direction: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      },
      Title: {
        text: {
          ...getFont(FONT.KINSHASA_3),
          textColor,
          textAlign: 'center',
          maxLines: 2,
        },
        flexItem: {
          marginBottom: TEXT_GAP[screenSize],
        },
      },
      Description: {
        text: {
          ...getFont(FONT.OTTAWA_1),
          textColor,
          textAlign: 'center',
          maxLines: 5,
        },
        flexItem: {
          marginBottom: TEXT_GAP[screenSize],
        },
      },
      Button: {
        flexItem: {
          marginTop: GAP[screenSize],
          marginBottom: GAP[screenSize],
        },
      },
      ExtraDetails: {
        text: {
          ...getFont(FONT.OTTAWA_1),
          textColor,
          textAlign: 'center',
          maxLines: 3,
        },
      },
    },
  });
};
